<template>
  <div>
    <modal v-if="informationModal" @close="closeModal" title="Atenção!" body='Caso queira entrar em contato agora com a Origami Turismo, 
      clique aqui para acessar o Whatsapp de atendimento <a href="https://wa.me/5521988190007" target="_blank" style="color: white; text-decoration: underline;"><i
    class="fa fa-whatsapp"></i> +55 21 98819-0007 (clique aqui)</a>.'>
    </modal>
    <infos :type="6" v-if="firstInfo" @nextButton="nextFirst" @goBack="changeTab"></infos>
    <div class="panel-group last-panel" v-if="!firstInfo">
      <div class="panel">
        <div class="col-md-12">
          <p>Veja mais quais itens você pode adquirir:</p>
          <hr />
          <div class="book-flight" id="book-flight">
            <div class="book-flight__panel">
              <div class="book-flight__panel__body in book-flight__panel__body--content">
                <br />
                <div>
                  <h5>&#x2022; Transfers</h5>
                  <h5>&#x2022; Diária de Hotel Extra</h5>
                  <h5>&#x2022; Passagem Aérea Extra</h5>
                  <h5>&#x2022; Seguro Viagem extra</h5>
                  <h5>&#x2022; Passeios</h5>
                  <h5>&#x2022; Chip</h5>
                </div>
                <br />
                <p>
                  Caso deseje adquirir algum serviço ou sanar alguma dúvida, por favor, entre em contato no nosso
                  atendimento Whatsapp <i class="fa fa-whatsapp"></i>&nbsp;&nbsp;<a href="https://wa.me/5521988190007"
                    target="_blank" style="text-decoration: underline">+55 21 98819-0007</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <custom-button @clicked="
      firstInfo = true;
    scrollOnTop();
    " myText="Voltar" icon="chevron-left" pos="left" v-if="!firstInfo"></custom-button>
    <custom-button myText="Próximo" icon="chevron-right" pos="right" @clicked="gotoFinishTab"
      v-if="!firstInfo"></custom-button>
  </div>
</template>

<script>
import { mixin } from "../../mixin.js";
import Infos from "../Infos.vue";
import CustomButtom from "../shared/CustomButton.vue";
import Modal from "../shared/Modal.vue";
export default {
  props: {
    participant: {
      type: Object,
      required: true,
    },
    accountProp: {
      type: Object,
      required: true,
    },
  },
  components: {
    Infos,
    "custom-button": CustomButtom,
    modal: Modal
  },
  mixins: [mixin],
  data: function () {
    return {
      user: this.participant,
      account: this.accountProp,
      firstInfo: true,
      informationModal: false,
    };
  },
  methods: {
    changeTab: function () {
      this.$emit("changeTab", "Termo de Imagem");
      this.scrollOnTop();
    },
    nextFirst: function () {
      this.firstInfo = false;
      this.scrollOnTop();
    },
    back: function () {
      this.firstInfo = true;
      this.scrollOnTop();
    },
    transfer: function (value) {
      this.$emit("handleTransfer", value);
    },
    gotoFinishTab: function () {
      this.informationModal = true;
    },
    closeModal: function () {
      this.informationModal = false;
      this.$emit("changeTab", "Conclusão");
      this.scrollOnTop();
    },
  },
  watch: {
    user: {
      handler: function (val) {
        this.$emit("handleUserChanged", val);
      },
      deep: true,
    },
    participant: function (val) {
      this.user = val;
    },
    account: function (val) {
      this.$emit("handleAccountChanged", val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/variables";

.guests-extras {
  background-color: rgba(0, 34, 71, 0.04);
  align-items: stretch;
  margin: 0;
  padding: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/tabs/Additional.vue